import { post, ServiceResult } from "@insite/client-framework/Services/ApiService";
import { SendWishListPdfApiParameter } from "@insite/client-framework/Services/WishListService";

const wishListUrl = "/api/v2/wishlists";

export async function customSendPdf(parameter: SendWishListPdfApiParameter): Promise<ServiceResult<any>> {
    try {
        const result = await post(`${wishListUrl}/${parameter.wishListId}/send-pdf`, parameter);
        return {
            successful: true,
            result,
        };
    } catch (error) {
        if ("status" in error && (error.status === 400 || error.status === 403)) {
            return {
                successful: false,
                errorMessage: error?.errorJson?.message || error?.errorMessage || "error",
                statusCode: error.status,
            };
        }
        throw error;
    }
}